export default __webpack_public_path__ + "static/media/masukkan_tempat.93ee7442.svg";